import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from '../../services/common/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { PasswordMessageDialogueComponent } from '../password-message-dialogue/password-message-dialogue.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-change-email-verfication',
  templateUrl: './change-email-verfication.component.html',
  styleUrl: './change-email-verfication.component.scss',
})
export class ChangeEmailVerficationComponent {
  maskedEmail = '';
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };
  verifyOtpForm!: FormGroup;
  email: string = '';
  userTypeId = 0;
  constructor(
    public dialog: MatDialog,
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private translate:TranslateService,
    private languageService: LanguageService,
  ) {
    this.verifyOtpForm = this.formBuilder.group({
      otp: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language);
    });
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.route.queryParams.subscribe((params) => {
      if (params.hasOwnProperty('email') && params.hasOwnProperty('userType')) {
        this.email = params['email'] || '';
        this.userTypeId = params['userType'] || 0;
        if (this.email && this.userTypeId) {
          let email = this.commonService.Decrypt(this.email);
          let userType = this.commonService.Decrypt(this.userTypeId.toString());
          this.email = email;
          this.userTypeId = parseInt(userType);
          this.maskedEmail = this.maskEmail(email)
          this.storageService.setValue('email', email);
        }
      }
    });
  }
  onVerifyOtp(event: any) {
    if (this.verifyOtpForm.valid) {
      const FormData = {
        otp: this.verifyOtpForm.controls['otp'].value.trim(),
        email: this.storageService.getValue('email'),
      };
      this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.account.verifyChangeEmailOTP;
      this.apiService
        .doPost(apiUrl, FormData)
        .pipe()
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            if (response && response.Success) {
              const dialogRef = this.dialog.open(
                PasswordMessageDialogueComponent,
                {
                  width: '600px',
                  data: {
                    // data will be based on API response
                    passwordError: false,
                    message:
                      'CHANGE_EMAIL_SUCCESS_MSG',
                    title: '',
                  },
                }
              );

              dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                  this.router.navigate(['/login']);
                }
              });
            } else {
              this.toaster.error(this.translate.instant(response.Message));
            }
          },
          error: (er) => {
            this.spinner.hide();
            console.error(er);
            this.toaster.error(er.Message);
          },
        });
    }
  }
  resendCode() {
    this.spinner.show();
    let email = this.storageService.getValue('email')
    const apiUrl = this.apiUrl.apiUrl.account.resendOTPChangeEmail.replace("{Email}",encodeURIComponent(email));
      this.apiService
        .doGet(apiUrl)
        .pipe()
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            if (response && response.Success) {
              this.toaster.success(this.translate.instant(response.Message));
            } else {
              this.toaster.error(this.translate.instant(response.Message));
            }
          },
          error: (er) => {
            this.spinner.hide();
            console.error(er);
            this.toaster.error(er.Message);
          },
        });
  }
  maskEmail(email: string): string {
    let parts = email.split('@');
    if (parts.length === 2) {
      let maskedLocal = parts[0].substring(0, 5) + '...'; // Show first 5 chars
      return maskedLocal + '@' + parts[1]; // Keep domain visible
    }
    return email; // Return original if not valid
  }
}
